import { t } from '../i18n/I18n.js';
import { CHANGELOG, type ChangelogEntry } from '../content/changelog.js';
import { escapeAttr } from '../html.js';

// The homepage shows only the newest releases; the rest stay on the page (and
// crawlable) behind a collapsed <details>, so the list can grow without the
// changelog dwarfing the games.
export const CHANGELOG_VISIBLE_COUNT = 5;

export function renderChangelog(): string {
  const recent = CHANGELOG.slice(0, CHANGELOG_VISIBLE_COUNT);
  const older = CHANGELOG.slice(CHANGELOG_VISIBLE_COUNT);
  const more = older.length === 0
    ? ''
    : `
      <details class="changelog-more">
        <summary>${t('changelog.showAll')}</summary>
        <ol class="changelog">${older.map(renderEntry).join('')}</ol>
      </details>
    `;
  return `
    <section class="section section-changelog" id="changelog">
      <h2 class="section-title">${t('changelog.sectionTitle')}</h2>
      <ol class="changelog">${recent.map(renderEntry).join('')}</ol>
      ${more}
    </section>
  `;
}

function renderEntry(entry: ChangelogEntry): string {
  const body = t(`changelog.entries.${entry.itemsKey}` as const);
  return `
    <li class="changelog-entry">
      <div class="changelog-meta">
        <time datetime="${escapeAttr(entry.date)}">${entry.date}</time>
        <span class="changelog-version">v${entry.version}</span>
      </div>
      <p>${body}</p>
    </li>
  `;
}
